import aesReduxConstants from '../constants';
import mapInspectApi from '../apis/mapInspectApi';

const mapInspectActions = function() {
  const actions = {};
  const constants = aesReduxConstants.MAP_INSPECT;

  const createErrorMessage = function(rawErrorMessage) {
    let title = 'An error occured';
    let details = '';
    if (rawErrorMessage.message !== undefined) {
      title = rawErrorMessage.message;
    }

    if (rawErrorMessage.details !== undefined) {
      details = rawErrorMessage.details;
    }

    return {
      title,
      details,
    };
  };

  actions.inspectLocationSuccess = function(results, area) {
    if (!results) {
      results = [{
        title: 'No Results Found',
      }];
    }
    if (!area) {
      area = [];
    }
    return {
      type: constants.INSPECT_LOCATION_SUCCESS,
      results,
      area,
    };
  };

  actions.inspectLocationError = function(rawErrorMessage) {
    return {
      type: constants.INSPECT_LOCATION_ERROR,
      errorMessage: createErrorMessage(rawErrorMessage),
    };
  };

  actions.updateInspectSettings = function(settings) {
    return {
      type: constants.UPDATE_INSPECT_LOCATION_SETTINGS,
      settings,
    };
  };

  actions.updateInspectLocation = function() {
    return function(dispatch, getState) {
      const contextState = getState().user.context;
      const { clientId } = contextState;
      const { userId } = contextState;
      const { inSwitchContext } = contextState;

      // set loading
      dispatch({ type: constants.INSPECT_LOCATION });
      const mapInspectSettings = getState().map.inspect.settings;
      const { inspectionArea } = mapInspectSettings;
      const { mapLayers } = mapInspectSettings;

      // check that inspection has happended
      if (inspectionArea.lat !== null || inspectionArea.lon != null) {
        let promise = null;
        if (inSwitchContext) {
          promise = mapInspectApi.inspectLocation(inspectionArea, mapLayers, clientId);
        } else {
          promise = mapInspectApi.inspectLocation(inspectionArea, mapLayers, clientId, userId);
        }

        promise.then((response) => {
          // var results = response.data.results;
          const results = response.data;
          // var area = response.data.area;
          dispatch(actions.inspectLocationSuccess(results, []));
          dispatch(actions.updateInspectSettings(inspectionArea));
        }, (error) => {
          const errorMessage = error.response.data;
          dispatch(actions.inspectLocationError(errorMessage));
        });
      }
    };
  };

  actions.inspectLocation = function(lat, lon, radius, extent, imageDisplay, mapLayers, callback) {
    return function(dispatch, getState) {
      const contextState = getState().user.context;
      const { clientId } = contextState;
      const { userId } = contextState;
      const { inSwitchContext } = contextState;

      // set loading
      dispatch({ type: constants.INSPECT_LOCATION });
      const inspectionArea = {
        lat,
        lon,
        radius,
        imageDisplay,
        extent,
      };

      let promise = null;
      if (inSwitchContext) {
        promise = mapInspectApi.inspectLocation(inspectionArea, mapLayers, clientId);
      } else {
        promise = mapInspectApi.inspectLocation(inspectionArea, mapLayers, clientId, userId);
      }

      promise.then((response) => {
        // var results = response.data.results;
        const results = response.data;
        // var area = response.data.area;
        dispatch(actions.inspectLocationSuccess(results, []));

        const settings = {
          inspectionArea,
          mapLayers,
        };
        dispatch(actions.updateInspectSettings(settings));

        if (callback !== undefined) {
          callback(results);
        }
      }, (error) => {
        const errorMessage = error.response.data;
        dispatch(actions.inspectLocationError(errorMessage));
      });
    };
  };

  return actions;
};

export default mapInspectActions();
